import * as z from "zod/v4";

import {
  partnerStatusSchema,
  partnerSummarySchema,
  partnerTypeSchema,
} from "./shared";

export const updatePartner = {
  name: "updatePartner" as const,
  input: z.object({
    partnerId: z.string(),
    /** All fields optional — only the supplied fields are updated. */
    name: z.string().min(1).max(200).optional(),
    status: partnerStatusSchema.optional(),
    partnerType: partnerTypeSchema.optional(),
  }),
  output: z.object({ partner: partnerSummarySchema }),
};
